<div class="proposition">
  <fa-icon icon="gift" size="lg"></fa-icon>
  <div class="proposition__text">
    <p class="proposition__title">
      {{ rendering.fields?.PropositionBoxTitle?.value }}
    </p>
    <p class="proposition__description">
      {{ rendering.fields?.PropositionBoxDescription?.value }}
    </p>

    @if (rendering.fields.PropositionMoreInfoModal) {
      <button
        class="btn btn-link proposition__info"
        (click)="openMoreInfoModal()"
      >
        {{ rendering.fields?.PropositionMoreInfoText?.value }}
      </button>
    }
  </div>
</div>
